<div class="select-container" [class.disabled]="disabled">
  <hyperkit-typography
    class="select-label"
    *ngIf="label && showLabel"
    variant="label1"
    color="inherit">
    {{label}}
  </hyperkit-typography>
  
  <div class="select-wrapper">
    <!-- Main select field -->
    <div 
      class="select-field" 
      [class.active]="state === 'active' && !disabled"
      [class.hover]="state === 'hover' && !disabled"
      [class.focused]="state === 'focused' && !disabled"
      [class.filled]="state === 'filled' && !disabled"
      [class.inactive]="state === 'inactive' || disabled"
      [class.error]="state === 'error' && !disabled"
      [class.has-chips]="selectedOptions.length > 0"
      (click)="!disabled && toggleDropdown()"
      (mouseenter)="!disabled && onMouseEnter()"
      (mouseleave)="!disabled && onMouseLeave()"
      tabindex="0"
      (keydown.enter)="!disabled && toggleDropdown()"
      (keydown.space)="!disabled && toggleDropdown()">
      
      <div class="select-value">
        <!-- Show placeholder when nothing is selected -->
        <hyperkit-typography
          *ngIf="selectedOptions.length === 0"
          class="placeholder"
          variant="body1"
          color="inherit">
          {{ placeholder }}
        </hyperkit-typography>
        
        <!-- Display chips for selected items -->
        <div class="chips-container" *ngIf="selectedOptions.length > 0">
          <div class="chip"  *ngFor="let option of visibleChips" >
            
            <hyperkit-tag
            [mode]="'fill'"
            [closable]="true"
            [text]="option.text"
            (tagComponentChange)="removeChip(option, $event)"
            >
          </hyperkit-tag>
          </div>
          
          <!-- Overflow chip -->
          <div class="chip overflow-chip" *ngIf="overflowCount > 0">
            <hyperkit-typography variant="label2" color="primary">
              +{{ overflowCount }}
            </hyperkit-typography>
          </div>
        </div>
      </div>
      
      <div class="select-arrow">
        <hyperkit-icon icon="chevron-down" color="inherit" size="medium"></hyperkit-icon>
      </div>
    </div>
  </div>
  
  <!-- Dropdown options -->
  <div class="select-dropdown" *ngIf="isOpen && !disabled">
    <hyperkit-dropdown-menu [isVisible]="isOpen">
      <hyperkit-dropdown-menu-section-header *ngIf="sectionHeader" [label]="sectionHeader"></hyperkit-dropdown-menu-section-header>
      <hyperkit-dropdown-menu-item 
        *ngFor="let option of internalOptions" 
        [label]="option.text"
        [selected]="isOptionSelected(option)"
        (click)="toggleOption(option, $event)"
        (keydown.enter)="toggleOption(option)"
        (keydown.space)="toggleOption(option)">
        <!-- You could add a checkbox icon here to indicate multiselect -->
        <hyperkit-icon 
          *ngIf="isOptionSelected(option)" 
          icon="check" 
          size="small" 
          slot="prefix"
          color="inherit">
        </hyperkit-icon>
      </hyperkit-dropdown-menu-item> 
    </hyperkit-dropdown-menu>
  </div>
</div>